export default "__VITE_ASSET__DfbKAHuL__"